import React, { useEffect } from 'react';
import {
  AppBar,
  AppBarDataCustomItem,
  AppBarDataDropdown,
  Button,
  DataGridTree,
  HeaderTabs,
} from '@ihsm/ui-shared';
import { PageContent } from 'shared/components/PageContent';
import { InnerPagePadding } from 'shared/components/InnerPagePadding/InnerPagePadding';
import { HeaderButtonWrapper } from 'shared/components/HeaderButtonWrapper';
import playIcon from 'shared/assets/icons/play.svg';
import { REPORTS_CONFIG_REPORT } from 'routes';
import { currentReportSelector } from 'state/store/selectors';
import { useAppSelector } from 'state/store';
import { useHistory } from 'react-router-dom';
import { useGetReportsQuery } from 'services/newApi/reportsConfigApi';
import { FullViewLoading } from 'shared/components/FullViewLoading';
import { SearchTreeReports } from '../components/SearchTreeReports';
import { useRunReportForm } from '../hooks';
import { getChildRows, getRowId } from '../utils';
import { RunReportModalForm } from '../components/RunReportModalForm';
import { DATE_OPTION, BENCH_OPTION, rowHeader } from '../constants';
import { useReportsReportData } from '../hooks/useReportsReportData';

export const ReportsReport: React.FC = () => {
  useGetReportsQuery();

  const {
    form,
    setForm,
    isLoading,
    isModalVisible,
    runReport,
    setModalVisible,
  } = useRunReportForm();

  const {
    headerTabs,
    dataColumns,
    reportDataList,
    fundsList,
    selectedFund,
    setSelectedFund,
    showLoading,
    isError,
  } = useReportsReportData();

  const currentReport = currentReportSelector(useAppSelector((state) => state));
  const { push } = useHistory();

  useEffect(() => {
    if (currentReport && (!currentReport?.jobId || !currentReport.jobTimestamp))
      push(REPORTS_CONFIG_REPORT);
  }, [currentReport, push]);

  const runReportButton: AppBarDataCustomItem = {
    type: 'customOption',
    component: (
      <HeaderButtonWrapper>
        <Button
          text="Run Report"
          onClick={() => setModalVisible(true)}
          iconSrc={playIcon}
          disabled={!currentReport}
        />
      </HeaderButtonWrapper>
    ),
  };

  const fundOption: AppBarDataDropdown = {
    type: 'dropdown',
    labelText: 'Fund',
    onChange: (value: string) => setSelectedFund(value),
    value: selectedFund,
    options: fundsList.map((fund) => ({
      displayText: fund,
      value: fund,
    })),
  };

  return (
    <>
      <PageContent
        searchTree={<SearchTreeReports />}
        headerControls={
          <AppBar
            menuItems={[DATE_OPTION, fundOption, BENCH_OPTION, runReportButton]}
          >
            <HeaderTabs items={headerTabs} />
          </AppBar>
        }
      >
        <FullViewLoading
          forceLoadingScreen={showLoading}
          forceNoDataScreen={isError}
        >
          <div className="reports-report">
            <InnerPagePadding>
              <DataGridTree
                idKey="rowId"
                rowHeader={rowHeader}
                dataColumns={dataColumns}
                data={reportDataList ?? []}
                getRowId={getRowId}
                getChildRows={getChildRows}
              />
            </InnerPagePadding>
          </div>
        </FullViewLoading>
      </PageContent>
      <RunReportModalForm
        form={form}
        setForm={setForm}
        onRun={runReport}
        onCancel={() => setModalVisible(false)}
        isLoading={isLoading}
        isVisible={isModalVisible}
        setVisible={setModalVisible}
      />
    </>
  );
};
